import React, { useState } from 'react';
import PropTypes from 'prop-types';
import validator from 'validator';
import pluralize from 'pluralize';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

import ReportProblemIcon from '@material-ui/icons/ReportProblem';

const TenantDialog = (props) => {
  const enabled = 'Enabled', disabled = 'Disabled';

  const rows = props.selectedRows;

  const initStatus = () => {
    let status = 'Active';
    if(rows.length === 1) {
      if(rows[0].status === 'Suspended')
        status = 'Suspend';
    }
    return status;
  };

  const initSptsStatus = () => rows.length === 1 ? rows[0].sptsStatus : enabled;

  const initProxyStatus = () => {
    let status = disabled;
    if(rows.length === 1) {
      if (rows[0].proxyStatus)
        status = rows[0].proxyStatus;
    }
    return status;
  }

  const initOne2MStatus = () => {
    let status = disabled;
    if(rows.length === 1) {
      if (rows[0].one2mStatus)
        status = rows[0].one2mStatus;
    }
    return status;
  }

  const [status, setStatus] = useState(initStatus);
  const [proxyStatus, setProxyStatus] = useState(initProxyStatus);
  const [one2mStatus, setOne2MStatus] = useState(initOne2MStatus);
  const [remName, setRemName] = useState('');
  const [newSptsStatus, setNewSptsStatus] = useState();
  const [nameError, setNameError] = useState(false);
  const [name, setName] = useState(props.name || '');
  const [sptsStatus, setSptsStatus] = useState(initSptsStatus);
  const [actionDisabled, setActionDisabled] = useState(false);
  const [openSptsDialog, setOpenSptsDialog] = useState(false);

  const actionByType = () => {
    if (props.type === 'create') {
      return (
        <Button variant='contained' color='primary' disabled={!name || nameError || actionDisabled} autoFocus
          onClick={() => {
            setActionDisabled(true);
            props.handleOk(name, status);
          }}
        >Create Tenant
        </Button>
      );
    } else if (props.type === 'edit') {
      return (
        <Button variant='contained' color='primary' disabled={actionDisabled} autoFocus
          onClick={() => {
            setActionDisabled(true);
            props.handleOk(status, sptsStatus, proxyStatus, one2mStatus);
          }}
        >
          Save changes
        </Button>
      );
    } else if (props.type === 'remove') {
      return (
        <Button variant='contained' color='primary' disabled={(remName !== 'yes') || actionDisabled} autoFocus
          onClick={() => {
            setActionDisabled(true);
            props.handleOk();
          }}
        >
          Remove Tenant
        </Button>);
    }
  };
  const titleByType = () => {
    if (props.type === 'create') {
      return 'Create Tenant';
    } else if (props.type === 'edit') {
      return 'Change Tenant Status';
    } else if (props.type === 'remove') {
      return (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <ReportProblemIcon style={{ marginRight: 8 }}/>
          <Typography>{`Remove ${pluralize('Tenant', props.count)}`}</Typography>
        </div>
      );
    }
  };
  const contentByType = () => {
    if (props.type === 'create') {
      return (
        <>
          <TextField label='Tenant Name' value={name} error={nameError}
            helperText={nameError ? 'Special symbols are not allowed' : ''}
            onChange={e => {
              const validate = e.target.value ? (!validator.isEmail(`a@${e.target.value}.com`)) : false;
              setNameError(validate);
              setName(e.target.value)
            }}
            fullWidth required
          />
          <TextField label='Status' value={status}
            onChange={e => setStatus(e.target.value)}
            select fullWidth required
          >
            {
              [ 'Active', 'Suspend'].map((item, idx) => {
                return (
                  <MenuItem key={idx} value={item}>{item}</MenuItem>
                );
              })
            }
          </TextField>
        </>
      );
    } else if (props.type === 'edit') {
      return (
        <>
          <div>
            <Typography>
              Selected tenant(s) will be Activated/Suspended
            </Typography>
            <TextField label='Status' value={status} onChange={e => setStatus(e.target.value)} select fullWidth required>
              {
                ['Active', 'Suspend']
                  .map((item, idx) => (<MenuItem key={idx} value={item}>{item}</MenuItem>))
              }
            </TextField>
          </div>
          <div style={{paddingTop: '24px'}}>
            <Typography>
              Selected tenant(s) SPTS status will be Enabled/Disabled
            </Typography>
            <TextField
              select
              required
              fullWidth
              label='Spts status'
              value={sptsStatus}
              onChange={e => {
                setOpenSptsDialog(true);
                setNewSptsStatus(e.target.value);
              }}
            >
              {
                [enabled, disabled]
                  .map((item, idx) => (<MenuItem key={idx} value={item}>{item}</MenuItem>))
              }
            </TextField>
          </div>
          <div style={{paddingTop: '24px'}}>
            <Typography>
              Proxy status
            </Typography>
            <TextField
              select
              required
              fullWidth
              label='Proxy status'
              value={proxyStatus}
              onChange={e => setProxyStatus(e.target.value)}
            >
              {
                [enabled, disabled]
                  .map((item, idx) => (<MenuItem key={idx} value={item}>{item}</MenuItem>))
              }
            </TextField>
          </div>
          <div style={{paddingTop: '24px'}}>
            <Typography>
              One2M status
            </Typography>
            <TextField
              select
              required
              fullWidth
              label='One2M status'
              value={one2mStatus}
              onChange={e => setOne2MStatus(e.target.value)}
            >
              {
                [enabled, disabled]
                  .map((item, idx) => (<MenuItem key={idx} value={item}>{item}</MenuItem>))
              }
            </TextField>
          </div>

        </>
      );
    } else if (props.type === 'remove') {
      return (
        <>
          <Typography>{`Are you sure want to delete selected ${pluralize('tenant', props.count)}?`}</Typography>
          <Typography color='primary'>{`All Data related to the ${pluralize('tenant', props.count)} will be permanently deleted. Confirm by typing the "yes" in the box below`}</Typography>
          <TextField label='yes' value={remName}
            onChange={e => setRemName(e.target.value)}
            fullWidth required
          />
        </>
      );
    }
  };

  const stpsDialog = () => {
    const statusText = newSptsStatus === 'Disabled' ? 'disable' : 'enable';
    return (
      <Dialog open={openSptsDialog}>
        <DialogTitle>Change Spts Status</DialogTitle>
        <DialogContent>
          <div>
            <Typography>
              {`Do you really want to ${statusText} the feature: SPTS?`}
            </Typography>
          </div>
        </DialogContent>
        <DialogActions>
          <Button variant='contained' onClick={() => setOpenSptsDialog(false)}>Cancel</Button>
          <Button
            color='primary'
            variant='contained'
            onClick={() => {
              setSptsStatus(newSptsStatus);
              setOpenSptsDialog(false);
            }}>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    )
  }

  return (
    <Dialog
      open={props.open}
      maxWidth='xs'
      fullWidth
    >
      <DialogTitle>{titleByType()}</DialogTitle>
      <DialogContent>
        {contentByType()}
        {stpsDialog()}
      </DialogContent>
      <DialogActions>
        <Button variant='contained' disabled={actionDisabled} onClick={props.handleCancel}>Cancel</Button>
        {actionByType()}
      </DialogActions>
    </Dialog>
  );
};

TenantDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  type: PropTypes.string,
  handleOk: PropTypes.func,
  handleCancel: PropTypes.func,
  name: PropTypes.string,
  status: PropTypes.string,
  count: PropTypes.number
};

export default TenantDialog;
